export default __webpack_public_path__ + "static/media/d2.0631b40e.png";